import { defaultTheme } from '../themes/theme';
import type { Breakpoint } from '../themes/types';

export const screenSizes: Record<Breakpoint, string> = {
  xs: `${defaultTheme.eclipseTier1.breakpoints.width.min.xs}px`,
  sm: `${defaultTheme.eclipseTier1.breakpoints.width.min.sm}px`,
  md: `${defaultTheme.eclipseTier1.breakpoints.width.min.md}px`,
  lg: `${defaultTheme.eclipseTier1.breakpoints.width.min.lg}px`,
  xl: `${defaultTheme.eclipseTier1.breakpoints.width.min.xl}px`,
} as const;

export const screenSizeMediaQueries = {
  '>=xs': `@media (min-width: ${screenSizes.xs})`,
  '>=sm': `@media (min-width: ${screenSizes.sm})`,
  '>=md': `@media (min-width: ${screenSizes.md})`,
  '>=lg': `@media (min-width: ${screenSizes.lg})`,
  '>=xl': `@media (min-width: ${screenSizes.xl})`,

  '<=xs': `@media (${screenSizes.sm} > width >= ${screenSizes.xs})`,
  '<=sm': `@media (${screenSizes.md} > width >= ${screenSizes.xs})`,
  '<=md': `@media (${screenSizes.lg} > width >= ${screenSizes.xs})`,
  '<=lg': `@media (${screenSizes.xl} > width >= ${screenSizes.xs})`,
  '<=xl': `@media (min-width: ${screenSizes.xs})`,

  xs: `@media (${screenSizes.sm} > width >= ${screenSizes.xs})`,
  sm: `@media (${screenSizes.md} > width >= ${screenSizes.sm})`,
  md: `@media (${screenSizes.lg} > width >= ${screenSizes.md})`,
  lg: `@media (${screenSizes.xl} > width >= ${screenSizes.lg})`,
  xl: `@media (min-width: ${screenSizes.xl})`,
} as const;

const isTouchDevice = '@media (pointer: coarse)';
const isPointerDevice = '@media (not (pointer: coarse))';
const isSmallDevice = screenSizeMediaQueries['<=md'];
const isLargeDevice = screenSizeMediaQueries['>=lg'];

export const deviceMediaQueries = {
  isSmallDevice,
  isLargeDevice,
} as const;

export const mq = {
  isTouchDevice,
  isPointerDevice,
  isSmallDevice,
  isLargeDevice,
  isTouchOrSmallDevice: `${isTouchDevice}, ${isSmallDevice.slice(7)}`,
  isPointerAndLargeDevice: `${isPointerDevice} and ${isLargeDevice.slice(7)}`,
  conditionalTransition: '@media (prefers-reduced-motion: no-preference)',
  supportsHover: `@media (hover: hover) and ${isPointerDevice.slice(7)}`,
  print: '@media print',
  prefersColorSchemeDark: '@media (prefers-color-scheme: dark)',
  ...screenSizeMediaQueries,
} as const;
